export enum PlanSlug {
  INBOX = 'inbox',
  AUTOMATION = 'automation',
  GRANDFATHERING = 'grandfathering',
}
